import React, { useEffect, useMemo } from 'react';
import { useAuth } from '../../hooks/useAuth';

const Intercom = ({ appId = 'ltuv7rn3', userData = {}, bootForAnonymous = false }) => {
  const { user } = useAuth();

  const stableUserData = useMemo(() => userData, [JSON.stringify(userData)]);

  useEffect(() => {
    const hasUser = !!user;
    const email = user?.email || stableUserData?.email;
    const name = user?.full_name || `${user?.first_name || ''} ${user?.last_name || ''}`.trim() || undefined;
    const user_id = user?.id ?? user?._id ? String(user.id ?? user._id) : undefined;

    if (!hasUser && !bootForAnonymous) {
      if (window.Intercom) {
        window.Intercom('shutdown');
      }
      delete window.Intercom;
      delete window.intercomSettings;
      return;
    }

    const userIdentification = {
      ...(email ? { email } : {}),
      ...(name ? { name } : {}),
      ...(user_id ? { user_id } : {}),
    };

    window.intercomSettings = {
      app_id: appId,
      alignment: 'right',
      horizontal_padding: 20,
      vertical_padding: 20,
      custom_launcher_selector: '',
      hide_default_launcher: false, 
      ...userIdentification,
      ...stableUserData,
    };

    (function() {
      var w = window;
      var d = document;
      var ic = w.Intercom;
      if (typeof ic === 'function') {
        ic('reattach_activator');
        ic('update', w.intercomSettings);
      } else {
        var i = function() { i.c(arguments); };
        i.q = [];
        i.c = function(args) { i.q.push(args); };
        w.Intercom = i;

        var l = function() {
          var s = d.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = `https://widget.intercom.io/widget/${appId}`;
          var x = d.getElementsByTagName('script')[0];
          x.parentNode.insertBefore(s, x);
        };

        if (d.readyState === 'complete') {
          l();
        } else if (w.attachEvent) {
          w.attachEvent('onload', l);
        } else {
          w.addEventListener('load', l, false);
        }
      }
    })();

    return () => {
      if (window.Intercom) {
        try { window.Intercom('shutdown'); } catch (e) { /* ignore */ }
      }
      delete window.Intercom;
      delete window.intercomSettings;
    };
  }, [appId, stableUserData, user, bootForAnonymous]);

  return null;
};

export default Intercom;
